import { useEffect, useMemo, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export default function useDocumentAllowance({
  onLimitNotReached,
  onLimitReached,
}) {
  const uuid = useMemo(() => uuidv4(), []);

  const [isDocumentAllowanceCheckPending, setIsDocumentAllowanceCheckPending] =
    useState(false);

  const {
    data: domainDocumentAllowance,
    isError,
    isFetching,
    isSuccess,
  } = useQuery({
    queryKey: ['documentAllowance', uuid],
    queryFn: async () => {
      const response = await axios.get('/document_allowance');
      return response.data;
    },
    enabled: isDocumentAllowanceCheckPending,
    staleTime: 0,
  });

  useEffect(() => {
    if (!isFetching && isSuccess) {
      domainDocumentAllowance.data.attributes.isDocumentLimitReached ?
        onLimitReached()
      : onLimitNotReached();

      setIsDocumentAllowanceCheckPending(false);
    }
  }, [isFetching, isSuccess]);

  useEffect(() => {
    if (!isFetching && isError) {
      setIsDocumentAllowanceCheckPending(false);
    }
  }, [isFetching, isError]);

  const handleDocumentAllowanceCheck = () => {
    setIsDocumentAllowanceCheckPending(true);
  };

  return {
    handleDocumentAllowanceCheck,
    isDocumentAllowanceCheckPending,
  };
}
